export const isAdmin = (user: any) => {
    return  user &&
            user.email &&
            user.email.toLowerCase().endsWith('jetstack.io');
  }